import { useEffect, useRef } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

/**
 * Sends the window back to the top on every client-side navigation, so a new
 * screen opens at its start rather than at the offset the previous one was
 * scrolled to.
 *
 * Keyed on the location, deliberately. The effect used to carry no dependency
 * array at all, which meant it ran after *every* render of the app shell — so
 * any state change while the user was reading (a fetch resolving, a filter
 * changing, a menu opening) yanked the page back to the top under them. Only a
 * navigation should move the scroll position.
 *
 * The first mount is skipped: the browser owns the scroll position on a fresh
 * page load, including restoring it on a reload or a back/forward step.
 */
const ScrollToTopComponent = ({ location }: RouteComponentProps) => {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  return null;
};

export const ScrollToTop = withRouter(ScrollToTopComponent);
